import { PlainButton } from "@jugl-web/ui-components/cross-platform/PlainButton";
import { Tooltip } from "@jugl-web/ui-components/cross-platform/Tooltip";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface DrawerHeaderNavButtonProps {
  children: ReactNode;
  tip?: string;
  className?: string;
  onClick?: () => void;
}

export const DrawerHeaderNavButton: FC<DrawerHeaderNavButtonProps> = ({
  children,
  tip,
  className,
  onClick,
}) => (
  <Tooltip
    isDisabled={!tip}
    className="px-3"
    renderTrigger={({ ref, props }) => (
      <PlainButton
        ref={ref}
        className={cx(
          "rounded-lg transition-colors hover:bg-grey-200",
          className
        )}
        onClick={onClick}
        {...props}
      >
        {children}
      </PlainButton>
    )}
  >
    {tip}
  </Tooltip>
);
